import { render, staticRenderFns } from "./email-add-or-update.vue?vue&type=template&id=112ff40e&"
import script from "./email-add-or-update.vue?vue&type=script&lang=js&"
export * from "./email-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports